import React from 'react'
import { Stack, Chip, Typography } from '@material-ui/core'
import ClickAwayTooltip from 'src/components/ClickAwayTooltip'
import { getStatusLabel, runTypeMapping } from '../utils/fileUtils'

const RunTypeDisplay = React.memo(({ row }) => {
  if (!row) return null

  // Check if it's a single FASTQ file
  if (row?.fastq_file_id && !row?.fastq_pair_id) {
    return <Chip label={'FASTQ Pair'} />
  }

  if (row?.fastq_pair_id) {
    const status = getStatusLabel(row)
    if (!row.sarek_run_type) return <Chip label={'FASTQ Analysis'} />

    const runType = row.sarek_run_type ? runTypeMapping[row.sarek_run_type][0] : 'FASTQ Analysis'
    const seenRunType = row.sarek_run_type ? runTypeMapping[row.sarek_run_type][1] : 'FASTQ Analysis'
    const bedName = row.sarek_bed_name ? row.sarek_bed_name : ''
    const normalPairName =
      row.normal_pair_1_name && row.normal_pair_2_name ? row.normal_pair_1_name + ' ' + row.normal_pair_2_name : null

    const realRunType = (
      <Typography variant="body1" sx={{ p: 0.5 }}>
        <>
          {runType}
          {normalPairName && (
            <>
              <br /> Normal Sample: <br /> {row.normal_pair_1_name}
              <br />
              {row.normal_pair_2_name}
            </>
          )}
        </>
      </Typography>
    )

    const realBedName = (
      <Typography variant="body1" sx={{ p: 0.5 }}>
        {bedName}
      </Typography>
    )

    return (
      <Stack direction="column" spacing={1}>
        <ClickAwayTooltip title={realRunType} placement="top" interactive>
          <Chip label={seenRunType} />
        </ClickAwayTooltip>
        {bedName !== 'WholeGenome' && (
          <ClickAwayTooltip title={realBedName} placement="top" interactive>
            <Chip label={'Covered Targets'} />
          </ClickAwayTooltip>
        )}
      </Stack>
    )
  }

  // Only show VCF Analysis for actual VCF files
  if (row?.vcf_id) {
    return row.original_reference !== 'Not specified yet.' ? (
      <ClickAwayTooltip title={`${row.original_reference}`} placement="top" interactive>
        <Chip label={'VCF Analysis'} />
      </ClickAwayTooltip>
    ) : (
      <Chip label={'VCF Analysis'} />
    )
  }

  return null
})

RunTypeDisplay.displayName = 'RunTypeDisplay'

export default RunTypeDisplay
